import {
  call,
  takeLatest
} from "redux-saga/effects";
import {
  downloadXLSFile
} from "utils/api";
import {
  defaultReturn,
  makePayload,
  generateDefaultActions
} from "store/utils/helpers";

export const EXPORT_PERSONAL_GUARANTORS = generateDefaultActions("EXPORT_PERSONAL_GUARANTORS");
export const exportPersonalGuarantors = payload => makePayload(EXPORT_PERSONAL_GUARANTORS.value, payload);
function* exportPersonalGuarantorsSaga(payload) {
  const url = `loans/${payload.id}/exportPersonalGuarantors`;
  yield call(downloadXLSFile, url, "POST", payload, "");
}

const initialState = {
  personalGuarantors: {

  }
};

export default function personalGuarantorsReducer(state = initialState, action) {
  const {
    type,
    payload,
    subKey
  } = action;
  switch (type) {
    case EXPORT_PERSONAL_GUARANTORS.success:
      return defaultReturn(state, payload.data, "personalGuarantors");
    default:
      return state;
  }
}

export function* personalGuarantorsSaga() {
  yield takeLatest(EXPORT_PERSONAL_GUARANTORS.value, exportPersonalGuarantorsSaga);
}
